import React from 'react';
import { VEC_ICON_NAME } from '../../icons/constants';
import { BUTTON_TYPE } from '../../button/constants';
import ConfirmationPopup from '../confirmationpopup/ConfirmationPopup';

export default function SelectAllConfirmationPopup ({
    isOpen = false,
    onConfirmationCb = () => {},
    onCancelCb = () => {},
}){
    return <>
        <ConfirmationPopup
            title={"Select All Action"}
            bodyText={"By enabling the Select All checkbox, you will be able to select items across all pages of the grid"}
            iconName = {VEC_ICON_NAME.WARNING_ICON}
            isOpen={isOpen}
            confirmationButtonProps = {{
                onConfirmationCb: (() => {
                    onConfirmationCb(); 
                    onCancelCb();
                }),
                confirmationButtonText: "Ok",
                confirmationButtonStyles: {},
                confirmationButtonType: BUTTON_TYPE.PRIMARY,
            }}
            cancelButtonProps = {{
                onCancelCb: onCancelCb,
                cancelButtonText: "Cancel",
                cancelButtonStyles: {},
                cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
            } }
            showClose={false}
        />
    </>
}